// v2 campaign lane file — see app/v2/README.md. Owned by one build agent at a time;
// other agents and humans: do not edit. Routes here are HIDDEN (reachable only via
// /v2-screens and deep links) and every element must wrap in <RequireAuth>.
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequireAuth } from '@/shared/auth/RequireAuth';

const EventLog2Page = lazy(() => import('@/features/warehouse/eventlog2/EventLog2Page'));
const LockBoard2Page = lazy(() => import('@/features/lock/v2/LockBoard2Page'));
const Alarms2Page = lazy(() => import('@/features/alarms/v2/Alarms2Page'));
const LocationStatus2Page = lazy(
  () => import('@/features/location/status2/LocationStatus2Page'),
);
const LocationMaintenance2Page = lazy(
  () => import('@/features/location/maintenance2/LocationMaintenance2Page'),
);
const LabelCentral2Page = lazy(() => import('@/features/labels/central2/LabelCentral2Page'));

export const slot6Routes: ReactElement[] = [
  <Route
    key="/system/event-log2"
    path="/system/event-log2"
    element={
      <RequireAuth>
        <EventLog2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/manage/system-locks2"
    path="/manage/system-locks2"
    element={
      <RequireAuth>
        <LockBoard2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/inquiry/alarms2"
    path="/inquiry/alarms2"
    element={
      <RequireAuth>
        <Alarms2Page />
      </RequireAuth>
    }
  />,
  // rank #39 — Location Status v2. Both the bare (lookup card) and the keyed forms, so the
  // /v2-screens index can link it param-free and a drill can deep-link it.
  <Route
    key="/location/status2"
    path="/location/status2"
    element={
      <RequireAuth>
        <LocationStatus2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/location/status2/:warehouseId/:locationId"
    path="/location/status2/:warehouseId/:locationId"
    element={
      <RequireAuth>
        <LocationStatus2Page />
      </RequireAuth>
    }
  />,
  // rank #49 — Location Maintenance v2 (read-first; see the page's contract header).
  <Route
    key="/location/maintenance2"
    path="/location/maintenance2"
    element={
      <RequireAuth>
        <LocationMaintenance2Page />
      </RequireAuth>
    }
  />,
  <Route
    key="/location/maintenance2/:locationId"
    path="/location/maintenance2/:locationId"
    element={
      <RequireAuth>
        <LocationMaintenance2Page />
      </RequireAuth>
    }
  />,
  // rank #50 — Label Center v2.
  <Route
    key="/labels/central2"
    path="/labels/central2"
    element={
      <RequireAuth>
        <LabelCentral2Page />
      </RequireAuth>
    }
  />,
];
